/** @format */

import { createContext, useContext } from "react";
import type { ParentGroupSummary } from "@question-bank/shared";
import type { PaperEntry } from "../../utils/paper";

export interface CartContextValue {
	addedQuestions: PaperEntry[];
	addWholeQuestion: (question: ParentGroupSummary) => void;
	addParts: (entry: PaperEntry) => void;
	removeQuestion: (entry: PaperEntry) => void;
	clearAll: () => void;
	entryFor: (parentQuestionId: string) => PaperEntry | undefined;
	reorderQuestions: (from: number, to: number) => void;
}

export const CartContext = createContext<CartContextValue | null>(null);

export const useCart = (): CartContextValue => {
	const cart = useContext(CartContext);
	if (cart === null) {
		throw new Error("useCart must be used within a CartProvider");
	}
	return cart;
};
